<div class="tw-relative tw-flex tw-items-center tw-justify-center">
  <div
    class="tw-h-6 tw-w-6 tw-rounded-full
      {{
      style === 'hud' ? 'tw-bg-dt-surface-card radio-hud-ring-shadow' : 'tw-bg-dt-surface-elevated'
    }}
      {{ style === 'hud' ? '' : isSelected ? 'tw-shadow-radio-inner' : 'tw-shadow-radio-outer' }}"
  ></div>
  <div
    class="tw-absolute tw-rounded-full tw-w-3 tw-h-3
      {{
      isSelected
        ? style === 'hud'
          ? 'radio-hud-selected-dot'
          : 'tw-bg-dt-custom-teal-9 tw-shadow-radio-lite'
        : 'tw-bg-dt-surface-card tw-shadow-radio-lite'
    }}"
  ></div>
</div>
